import type { AsyncData } from "#app";
import type { IModelListQueryParamsRequest, IModelResponse } from "~/services/base/dto/base.dto";
import type { IModelRoleDetailResponse, IModelRolesResponse, ModelRoleDetail } from "./dto/roles.dto";
import type { IModelPermissionResponse } from "./dto/permission.dto";

export class RolesRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getRoleList(
    params: any
  ): Promise<AsyncData<IModelResponse<IModelRolesResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/role`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getPermissionList(
    params: IModelListQueryParamsRequest
  ): Promise<AsyncData<IModelResponse<IModelPermissionResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/permission`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getRoleDetail(
    id: number | string
  ): Promise<AsyncData<IModelResponse<IModelRoleDetailResponse>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/role-relation/${id}`,
      this.configService
    );
    return dataResult;
  }

  async createRole(params: any): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/role-relation`,
      this.configService,
      {
        method: "POST",
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async updateRole(params: any): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/role-relation`,
      this.configService,
      {
        method: "PUT",
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  } 
  
}